import * as fb from '../firebase';

export default {
  joinWorkspace(userId, workspaceId) {
    const joinWorkspaceFn = fb.functions.httpsCallable('joinWorkspace');
    return joinWorkspaceFn({ userId, workspaceId })
      .then((result) => {
        return result.data;
      })
      .catch((error) => {
        throw new Error(error);
      });
  },
};
